import { userAccessEnum } from "../../config/accessEnum";
import useStore from "../../context/useStore";

const useAccessSettings = () => {
  const [state] = useStore();
  const userPermissions = state.auth.user.permissions;

  let authorizations = {};

  if (userPermissions) {
    Object.keys(userAccessEnum).forEach((access) => {
      let entry = userAccessEnum[access];
      authorizations[entry] = () => ({
        granted: userPermissions.includes(entry),
      });
    });
  }

  const accessActions = {
    canI: ({ action }) => {
      if (action === "*") {
        return { granted: true };
      }
      if (typeof action === "string") {
        if (authorizations[action]) return authorizations[action]();
      }
      if (typeof action === "object") {
        for (var key in action) {
          if (authorizations[action[key]]) {
            let res = authorizations[action[key]]();
            if (res.granted) {
              return { granted: true };
            }
          }
        }
        return { granted: false };
      }
      return { granted: false };
    },
  };

  return {
    accessActions,
  };
};

export default useAccessSettings;
